import styled from 'styled-components';

export const StyledWelcomeContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background-color: #f9f7f1;
`;
